import { enableProdMode } from '@angular/core'
import { bootstrapApplication } from '@angular/platform-browser'
import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'
import { environment } from './environments/environment'
import { devTools } from '@ngneat/elf-devtools'
import { AwsRum, AwsRumConfig } from 'aws-rum-web'

if (environment.production) {
  enableProdMode()
} else {
  devTools()
}

bootstrapApplication(AppComponent, appConfig)
  .then(ref => {
    if (window['ngRef']) {
      window['ngRef'].destroy()
    }
    window['ngRef'] = ref
  })
  .catch(err => console.error(err))
